import { apiClient } from '../../../services/api/client';

export const rolesAPI = {
  // Get department roles
  getDepartmentRoles: () => 
    apiClient.get('/api/v1/ac/roles/'),
  
  // Create role
  createRole: (data) => 
    apiClient.post('/api/v1/ac/roles/', data),
  
  // Get role by ID
  getRoleById: (roleId) => 
    apiClient.get(`/api/v1/ac/roles/${roleId}`),
  
  // Update role
  updateRole: (roleId, data) => 
    apiClient.put(`/api/v1/ac/roles/${roleId}`, data),
  
  // Delete role
  // Pass { force: true } to delete a role that still has staff assigned
  deleteRole: (roleId, params = {}) =>
    apiClient.delete(`/api/v1/ac/roles/${roleId}`, { params }),
  
  // Get role permissions
  getRolePermissions: (roleId) => 
    apiClient.get(`/api/v1/ac/roles/${roleId}/permissions`),
  
  // Add permission to role
  addPermission: (roleId, data) => 
    apiClient.post(`/api/v1/ac/roles/${roleId}/permissions`, data),
  
  // Remove permission from role
  removePermission: (roleId, permissionId) => 
    apiClient.delete(`/api/v1/ac/roles/${roleId}/permissions/${permissionId}`),
  
  // Bulk add permissions to role
  bulkAddPermissions: (roleId, data) => 
    apiClient.post(`/api/v1/ac/roles/${roleId}/permissions/bulk-add`, data),
  
  // Bulk remove permissions from role
  bulkRemovePermissions: (roleId, data) => 
    apiClient.post(`/api/v1/ac/roles/${roleId}/permissions/bulk-delete`, data),
};